import { useSelector } from 'react-redux';

export const usePermission = (perm) => {
  const permissions = useSelector((state) => state.auth.permissions);
  return permissions.includes(perm);
};
